export const companyStudentDeviceSid = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
